import React, { useEffect, useState } from 'react';
import { Col, Container, Image, Nav, Row, Form, Modal } from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import '../../Assets/css/header.css';
import logoImage from '../../Assets/images/dfl_logo.webp';
// import logoImage from '../../Assets/images/logo.png';
import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@material-ui/core/';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import menuImages from '../../Assets/images/menu.png';
import { base_url, isLogin, postHeader } from '../../Helpers/request';
import { isMobile, isMobileOnly, isTablet } from 'react-device-detect';
import { BiUser } from 'react-icons/bi';
import { AiOutlineClose } from 'react-icons/ai';
import Heart1 from '../../Assets/images/icon/heart.png';
import Cart1 from '../../Assets/images/icon/bag.png';
import Magnify0 from '../../Assets/images/icon/search.png';
import { useSelector } from 'react-redux';
import { Button, Drawer, Menu, MenuItem } from '@mui/material';
import User1 from '../../Assets/images/icon/users.png';
import { cartlengthvalue } from '../../Reducer/cartReducer';
import { useDispatch } from 'react-redux';
import { whishlistlength } from '../../Reducer/wishlistReducer';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import axios from 'axios';
import loaderImg from '../../Assets/images/preloader.gif';
import { BsFillChatFill } from 'react-icons/bs';
// import {IoCall} from 'react-icons/io'
import { MdEmail, MdOutlineCall } from 'react-icons/md';
import { AiOutlineContacts } from 'react-icons/ai';
import { isDesktop } from 'react-device-detect';
import { VscCalendar } from 'react-icons/vsc';
import CalanderrImg from '../../Assets/images/DFL/calander-white.png';
import EmailImg from '../../Assets/images/DFL/email-img.png';
import TelephoneImg from '../../Assets/images/DFL/telephone.png';
import HoliDaysHeading from '../Front/HoliDaysHeading';
import CanadaFlagImg from '../../Assets/images/DFL/canada-flag-img.png'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
}));
const Header = () => {
  const [preloader, setpreloader] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setpreloader(false);
    }, 1000);
    setpreloader(true);
    document.body.className = window.location.pathname;
    return () => {
      document.body.className = '';
    };
  }, [window.location.pathname]);

  const dispatch = useDispatch();
  const history = useHistory();
  const [isScrollValueMoreThanHeaderHeight, setIsScrollValueMoreThanHeaderHeight] = useState(false);
  const [topHeader, setTopHeader] = useState(true);
  const [left, setLeft] = useState(false);
  const [search_text, setSearch_text] = useState('');
  const [search_show, setSearch_show] = useState(false);

  const [isShown, setIsShown] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);

  const cartlength = useSelector((state) => state.persistedReducer.cart.cartlength);
  const wishlistlength = useSelector((state) => state.persistedReducer.wish.whishlistlength);
  const user = JSON.parse(localStorage.getItem('dfl-user')) ? JSON.parse(localStorage.getItem('dfl-user')) : false;

  const toggleDrawer = (open) => {
    setLeft(open);
  };
  const classes = useStyles();
  const handleClicktop = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClosetop = () => {
    setAnchorEl(null);
  };
  const handlelogout = () => {
    localStorage.removeItem('dfl-user');
    dispatch(whishlistlength(0));
    dispatch(cartlengthvalue(0));
    localStorage.removeItem('dfl-session-id');
    setAnchorEl(null);
    history.push('/');
    window.location.reload(true);
  };
  //-----------------------------------menu
  const device_type = isDesktop ? 1 : 2;

  const [menudata, setMenudata] = useState([]);
  useEffect(() => {
    axios
      .get(base_url + '/home/menu?device_type=' + device_type, {
        headers: postHeader,
      })
      .then((response) => {
        if (response.data.status == 1) {
          setMenudata(response.data.data);
        } else {
          console.log(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    const handleScroll = () => {
      setIsScrollValueMoreThanHeaderHeight(window.scrollY > 15);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return (
    <>
      {preloader && (
        <div className="preloader position-fixed w-100 h-100 text-center d-flex align-items-center justify-content-center">
          <img src={loaderImg} alt="Loader Image" className="dfl_loader_diamond_img" />
        </div>
      )}

      <div className="rcs_header_seaction" id="rcs_header_seaction">
        <div className="dfl_new_top_hader0">
          <Container fluid>
            <Row>
              {isMobileOnly ?

                  <div className="dfl_new_top_hader0_outer">
                      <a href="tel:+1 416 362 9944"  className="dfl_new_top_hader0_inner"><svg stroke="currentColor" fill="#fff" stroke-width="0" viewBox="0 0 512 512" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg"><path d="M391 480c-19.52 0-46.94-7.06-88-30-49.93-28-88.55-53.85-138.21-103.38C116.91 298.77 93.61 267.79 61 208.45c-36.84-67-30.56-102.12-23.54-117.13C45.82 73.38 58.16 62.65 74.11 52a176.3 176.3 0 0 1 28.64-15.2c1-.43 1.93-.84 2.76-1.21 4.95-2.23 12.45-5.6 21.95-2 6.34 2.38 12 7.25 20.86 16 18.17 17.92 43 57.83 52.16 77.43 6.15 13.21 10.22 21.93 10.23 31.71 0 11.45-5.76 20.28-12.75 29.81-1.31 1.79-2.61 3.5-3.87 5.16-7.61 10-9.28 12.89-8.18 18.05 2.23 10.37 18.86 41.24 46.19 68.51s57.31 42.85 67.72 45.07c5.38 1.15 8.33-.59 18.65-8.47 1.48-1.13 3-2.3 4.59-3.47 10.66-7.93 19.08-13.54 30.26-13.54h.06c9.73 0 18.06 4.22 31.86 11.18 18 9.08 59.11 33.59 77.14 51.78 8.77 8.84 13.66 14.48 16.05 20.81 3.6 9.53.21 17-2 22-.37.83-.78 1.74-1.21 2.75a176.49 176.49 0 0 1-15.29 28.58c-10.63 15.9-21.4 28.21-39.38 36.58A67.42 67.42 0 0 1 391 480z"></path></svg></a>
                    <NavLink to="/make-an-appointment" className="dfl_new_top_hader0_inner">
                      <Image src={CalanderrImg} alt="Calander Image" className="img-fluid" />
                      {/* <span className={isMobile ? 'border-right-0':''}>Book Your Free Consultation</span> */}
                    </NavLink>
                    <a href="mailto:info@diamondsforless.ca" target="_blank" className="dfl_new_top_hader0_inner">
                      <Image src={EmailImg} alt="Calander Image" className="img-fluid img_mail" />
                      {/* <span className={isMobile ? 'border-right-0':''}>info@diamondsforless.ca</span> */}
                    </a>
                  

                  </div> :
                  <div className="dfl_new_top_hader0_outer">
                    <NavLink to="/make-an-appointment" className="dfl_new_top_hader0_inner">
                      <Image src={CalanderrImg} alt="Calander Image" className="img-fluid" />
                      <span className={isMobile ? 'border-right-0' : ''}>Book Your Free Consultation</span>
                    </NavLink>
                    <a href="mailto:info@diamondsforless.ca" target="_blank" className="dfl_new_top_hader0_inner">
                      <Image src={EmailImg} alt="Calander Image" className="img-fluid img_mail" />
                      <span className={isMobile ? 'border-right-0' : ''}>info@diamondsforless.ca</span>
                    </a>
                    <NavLink to="/" target="_blank" className="dfl_new_top_hader0_inner img_flag_text d-none d-sm-none d-md-block">
                      <Image src={CanadaFlagImg} alt="Canada Flag Image" className="img-fluid img_flag" />
                      <span className="border-right-0">Shop Local. Skip the Tariffs.
                        Canadian-owned, Canadian-made. No surprise duties or border delays.</span>
                    </NavLink>
                  </div>
                }
            </Row>
          </Container>
        </div>
        {topHeader ? (
          <div className="rcs_top_header">
            {isMobile && <div className="dfl_header_top_mobile_view">
              <Container>
                <Row className="w-100 m-auto">
                  <Col sm={12} md={12} lg={12} className='p-0'>
                    {isMobileOnly && <NavLink to="/" target="_blank" className="dfl_new_top_hader0_inner img_flag_text mr-0">
                      <Image src={CanadaFlagImg} alt="Canada Flag Image" className="img-fluid img_flag" />
                      <span className="border-right-0">Shop Local. Skip the Tariffs.
                        Canadian-owned, Canadian-made. No surprise duties or border delays.</span>
                    </NavLink>}
                    <div className="text-center m-auto dfl_number_with_calender_box">
                      <VscCalendar className="dfl_ringb_calander_icon dfl_calander_hide" onClick={() => history.push('/make-an-appointment')} title="Book An Appointment" />
                      <div className="dfl_top_right_number">
                        {/* <Button
                        onClick={(e) => {
                          window.location.href = `tel:+1 416 362 9944`;
                        }}
                        className="text-uppercase non_btn fw600 fs15 d-flex align-items-center dfl_text_contact"
                      >
                       
                        <span style={{ marginLeft: "3px", color: "#000" }}>
                          +1 416 362 9944
                        </span>
                      </Button> */}

                        {/* <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"></path>
                        </svg>
                        <a href="tel:+1 416 362 9944">+1 416 362 9944 </a> */}
                        {/* <NavLink
                        to="#"
                        target="_blank"
                        onClick={(e) => {
                          window.location.href = `tel:+14163629944`;
                        }}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          strokeWidth="0"
                          viewBox="0 0 16 16"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"></path>
                        </svg>
                        <span className="text-uppercase dark ">
                          +1 (416)362-9944
                        </span>
                      </NavLink> */}
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>}

            <Container>
              <div className="rcs_top_head_content">
                <div className="rcs_top_head_content">
                  <Row className="w-100 m-auto align-items-center">
                    <Col lg={4} sm={12} className="d-xs-none">
                      <div className="dfl_number_with_calender_box justify-content-start">
                        <VscCalendar className="dfl_ringb_calander_icon dfl_calander_display_none_in_tab" onClick={() => history.push('/make-an-appointment')} title="Book An Appointment" />
                        <div className="dfl_top_right_number">
                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"></path></svg>

                          <a href="tel:+1 416 362 9944">+1 416 362 9944</a>
                        </div>
                      </div>
                    </Col>
                    <Col lg={4} sm={12} className="pl-0">
                      <div className="dfl_header_logo text-center">
                        <Nav className="m-auto rcs_mobile_header_menu">
                          <Image onClick={() => toggleDrawer(true)} src={menuImages} alt="menu icon" width="30px"></Image>
                        </Nav>
                        <Image className="dfl_logo_top_m" style={{ cursor: 'pointer' }} onClick={() => history.push('/')} src={logoImage} alt="DFL LOGO Image"></Image>
                      </div>
                    </Col>

                    <Col lg={4} className="pl-0">
                      {/* <div className='dfl_new_header_top_row'>
  
        <div className='rcs_search_bar dfl_top_search'>
            <Form onSubmit={(e) => { e.preventDefault(); history.push('/search/' + search_text); window.scrollTo(0, 0); setSearch_text(""); setSearch_show(false); }}>
                <Form.Control type="text"
                    placeholder="Search"
                    value={search_text}
                    onChange={(e) => setSearch_text(e.target.value)}
                />
                <SearchIcon onClick={(e) => { history.push('/search/' + search_text); setSearch_text(""); setSearch_show(false); }} />
            </Form>
        </div>
</div> */}
                      <div>
                        <div className="dfl_top_right_cont_main mt-2">
                          <div className="rcs_search_bar dfl_top_search">
                            <div className="rcs_right_side dfl_right_icn_content ">
                              <ul>
                                <li className="d-none d-lg-block d-md-block dfl_tab_search position-relative" onClickAway={() => setSearch_show(false)}>
                                  <img onClick={() => setSearch_show(!search_show)} className="rcs_wishlist_icon" src={Magnify0} alt={Magnify0} />
                                  <Modal className={isScrollValueMoreThanHeaderHeight ? 'rcs_search_modal12' : 'rcs_search_modal'} show={search_show} onHide={() => setSearch_show(false)}>
                                    <div className="rcs_search_bar">
                                      <Form
                                        onSubmit={(e) => {
                                          e.preventDefault();
                                          history.push('/search/' + search_text);
                                          window.scrollTo(0, 0);
                                          setSearch_text('');
                                          setSearch_show(false);
                                        }}
                                      >
                                        <SearchIcon
                                          onClick={(e) => {
                                            history.push('/search/' + search_text);
                                            setSearch_text('');
                                            setSearch_show(false);
                                          }}
                                        />
                                        <Form.Control type="text" placeholder="Search for.." value={search_text} onChange={(e) => setSearch_text(e.target.value)} />
                                        <AiOutlineClose onClick={() => setSearch_show(!search_show)} />
                                      </Form>
                                    </div>
                                  </Modal>
                                </li>
                                {isLogin ? (
                                  <>
                                    <Button className="rcs_blank_button rcs_after_login_button" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClicktop}>
                                      {isMobileOnly ? (
                                        <span className="rcs_mobile">{user.first_name[0]}</span>
                                      ) : isTablet ? (
                                        <span className="rcs_mobile">{user.first_name[0]}</span>
                                      ) : (
                                        <span className="rcs_mobile">
                                          {user.first_name[0]} <KeyboardArrowDownIcon />{' '}
                                        </span>
                                      )}
                                    </Button>
                                    <Menu id="simple-menu" anchorEl={anchorEl} keepMounted className="rcs_menu_list_item" open={Boolean(anchorEl)} onClick={handleClosetop}>
                                      <MenuItem disabled>
                                        <BiUser /> {user.first_name}
                                      </MenuItem>
                                      <MenuItem onClick={() => history.push('/account/myaccount')}>My Account</MenuItem>
                                      <MenuItem onClick={handlelogout}>Logout</MenuItem>
                                    </Menu>
                                  </>
                                ) : (
                                  <li className="position-relative" onClick={() => history.push('/login')}>
                                    {' '}
                                    <img className="rcs_wishlist_icon" src={User1} alt={User1} />{' '}
                                    <span className="dfl_right_menu_text" style={{ cursor: 'pointer' }}>
                                      {' '}
                                    </span>{' '}
                                  </li>
                                )}
                                <li className="position-relative" onClick={() => (isLogin ? history.push('/account/wishlist') : history.push('/wishlist'))}>
                                  {' '}
                                  <img className="rcs_wishlist_icon" src={Heart1} alt={Heart1} />{' '}
                                  <span className="dfl_right_menu_text" style={{ cursor: 'pointer' }}>
                                    {' '}
                                  </span>
                                  {wishlistlength && wishlistlength != '0' ? <span className="rcs_wish_badge">{wishlistlength}</span> : ''}{' '}
                                </li>
                                <li
                                  className="position-relative"
                                  onClick={() => {
                                    history.push('/cart');
                                  }}
                                >
                                  <img className="rcs_wishlist_icon" src={Cart1} alt={Cart1} />{' '}
                                  <span className="dfl_right_menu_text" style={{ cursor: 'pointer' }}>
                                    {' '}
                                  </span>{' '}
                                  {cartlength && cartlength != '0' ? <span className="rcs_cart_badge">{cartlength} </span> : ''}{' '}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Container>
          </div>
        ) : (
          ''
        )}
        {/* Top Header Section */}
        <div className={isScrollValueMoreThanHeaderHeight ? 'rcs_logo_head rcs_sticky-top sticky-top' : 'rcs_logo_head'}>
          {/* Header Section */}
          <div className="dfl_new_top_hader0 dfl_top_new_header0__on_sticky">
            <Container fluid>
              <Row>

                {isMobileOnly ?

                  <div className="dfl_new_top_hader0_outer">
                     <a href="tel:+1 416 362 9944" className="dfl_new_top_hader0_inner"><svg stroke="currentColor" fill="#fff" stroke-width="0" viewBox="0 0 512 512" height="200px" width="200px" xmlns="http://www.w3.org/2000/svg"><path d="M391 480c-19.52 0-46.94-7.06-88-30-49.93-28-88.55-53.85-138.21-103.38C116.91 298.77 93.61 267.79 61 208.45c-36.84-67-30.56-102.12-23.54-117.13C45.82 73.38 58.16 62.65 74.11 52a176.3 176.3 0 0 1 28.64-15.2c1-.43 1.93-.84 2.76-1.21 4.95-2.23 12.45-5.6 21.95-2 6.34 2.38 12 7.25 20.86 16 18.17 17.92 43 57.83 52.16 77.43 6.15 13.21 10.22 21.93 10.23 31.71 0 11.45-5.76 20.28-12.75 29.81-1.31 1.79-2.61 3.5-3.87 5.16-7.61 10-9.28 12.89-8.18 18.05 2.23 10.37 18.86 41.24 46.19 68.51s57.31 42.85 67.72 45.07c5.38 1.15 8.33-.59 18.65-8.47 1.48-1.13 3-2.3 4.59-3.47 10.66-7.93 19.08-13.54 30.26-13.54h.06c9.73 0 18.06 4.22 31.86 11.18 18 9.08 59.11 33.59 77.14 51.78 8.77 8.84 13.66 14.48 16.05 20.81 3.6 9.53.21 17-2 22-.37.83-.78 1.74-1.21 2.75a176.49 176.49 0 0 1-15.29 28.58c-10.63 15.9-21.4 28.21-39.38 36.58A67.42 67.42 0 0 1 391 480z"></path></svg></a>
                    <NavLink to="/make-an-appointment" className="dfl_new_top_hader0_inner">
                      <Image src={CalanderrImg} alt="Calander Image" className="img-fluid" />
                      {/* <span className={isMobile ? 'border-right-0':''}>Book Your Free Consultation</span> */}
                    </NavLink>
                    <a href="mailto:info@diamondsforless.ca" target="_blank" className="dfl_new_top_hader0_inner">
                      <Image src={EmailImg} alt="Calander Image" className="img-fluid img_mail" />
                      {/* <span className={isMobile ? 'border-right-0':''}>info@diamondsforless.ca</span> */}
                    </a>
                   

                  </div> :
                  <div className="dfl_new_top_hader0_outer">
                    <NavLink to="/make-an-appointment" className="dfl_new_top_hader0_inner">
                      <Image src={CalanderrImg} alt="Calander Image" className="img-fluid" />
                      <span className={isMobile ? 'border-right-0' : ''}>Book Your Free Consultation</span>
                    </NavLink>
                    <a href="mailto:info@diamondsforless.ca" target="_blank" className="dfl_new_top_hader0_inner">
                      <Image src={EmailImg} alt="Calander Image" className="img-fluid img_mail" />
                      <span className={isMobile ? 'border-right-0' : ''}>info@diamondsforless.ca</span>
                    </a>
                    <NavLink to="/" target="_blank" className="dfl_new_top_hader0_inner img_flag_text d-none d-sm-none d-md-block">
                      <Image src={CanadaFlagImg} alt="Canada Flag Image" className="img-fluid img_flag" />
                      <span className="border-right-0">Shop Local. Skip the Tariffs.
                        Canadian-owned, Canadian-made. No surprise duties or border delays.</span>
                    </NavLink>
                  </div>
                }
              </Row>
            </Container>
          </div>
          <div className="rcs_header">
            <div className="dfl_header_top_mobile_view">
              {isMobileOnly && <Container>
                <Row className="w-100 m-auto">
                  <Col sm={12} md={12} lg={12} className='p-0'>
                    <NavLink to="/" target="_blank" className="dfl_new_top_hader0_inner img_flag_text mr-0">
                      <Image src={CanadaFlagImg} alt="Canada Flag Image" className="img-fluid img_flag" />
                      <span className="border-right-0">Shop Local. Skip the Tariffs.
                        Canadian-owned, Canadian-made. No surprise duties or border delays.</span>
                    </NavLink>
                    <div className="text-center m-auto d-flex justify-content-center align-items-center">
                      <VscCalendar className="dfl_ringb_calander_icon dfl_call_display_none_in_desktop_view" onClick={() => history.push('/make-an-appointment')} title="Book An Appointment" />
                      {/* <div className="dfl_top_right_number">
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"></path>
                        </svg>

                        <a href="tel:+1 416 362 9944">+1 416 362 9944</a>
                      </div> */}
                    </div></Col>
                </Row>
              </Container>}
            </div>
            <Container className="dfl_header_container  p-0">
              <Row className="w-100 m-auto align-items-center justify-content-center">
                <Col sm={12} md={12} lg={3} xl={3} xs={12} className="rcs_large_Tab dfl_sticky_logo">
                  <div className="dfl_header_logo_top dfl_mob">
                    <div className="dfl_header_fixed_logo">
                      <Image style={{ cursor: 'pointer' }} onClick={() => history.push('/')} src={logoImage} alt="DFL Logo Image"></Image>
                    </div>
                    <div className="m-auto rcs_mobile_header_menu">
                      <Image onClick={() => toggleDrawer(true)} src={menuImages} alt="menu icon" width="30px"></Image>
                    </div>
                  </div>

                  {/* fixed header wishlist search and login icon  */}
                  <div className="rcs_right_side dfl_right_icn_content dfl_mobile_icn">
                    <ul>
                      <li className="d-none d-lg-block d-md-block dfl_tab_search " onClickAway={() => setSearch_show(false)}>
                        <img onClick={() => setSearch_show(!search_show)} className="rcs_wishlist_icon" src={Magnify0} alt={Magnify0} />
                        <Modal className={isScrollValueMoreThanHeaderHeight ? 'rcs_search_modal12' : 'rcs_search_modal'} show={search_show} onHide={() => setSearch_show(false)}>
                          <div className="rcs_search_bar">
                            <Form
                              onSubmit={(e) => {
                                e.preventDefault();
                                history.push('/search/' + search_text);
                                window.scrollTo(0, 0);
                                setSearch_text('');
                                setSearch_show(false);
                              }}
                            >
                              <SearchIcon
                                onClick={(e) => {
                                  history.push('/search/' + search_text);
                                  setSearch_text('');
                                  setSearch_show(false);
                                }}
                              />
                              <Form.Control type="text" placeholder="Search for.." value={search_text} onChange={(e) => setSearch_text(e.target.value)} />
                              <AiOutlineClose onClick={() => setSearch_show(!search_show)} />
                            </Form>
                          </div>
                        </Modal>
                      </li>
                      {isLogin ? (
                        <>
                          <Button className="rcs_blank_button rcs_after_login_button" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClicktop}>
                            {isMobileOnly ? (
                              <span className="rcs_mobile">{user.first_name[0]}</span>
                            ) : isTablet ? (
                              <span className="rcs_mobile">{user.first_name[0]}</span>
                            ) : (
                              <span className="rcs_mobile">
                                {user.first_name[0]} <KeyboardArrowDownIcon />{' '}
                              </span>
                            )}
                          </Button>
                          <Menu id="simple-menu" anchorEl={anchorEl} keepMounted className="rcs_menu_list_item" open={Boolean(anchorEl)} onClick={handleClosetop}>
                            <MenuItem disabled>
                              <BiUser /> {user.first_name}
                            </MenuItem>
                            <MenuItem onClick={() => history.push('/account/myaccount')}>My Account</MenuItem>
                            <MenuItem onClick={handlelogout}>Logout</MenuItem>
                          </Menu>
                        </>
                      ) : (
                        <li className="" onClick={() => history.push('/login')}>
                          {' '}
                          <img className="rcs_wishlist_icon" src={User1} alt={User1} />{' '}
                          <span className="dfl_right_menu_text" style={{ cursor: 'pointer' }}>
                            {' '}
                            Login{' '}
                          </span>{' '}
                        </li>
                      )}
                      <li className="" onClick={() => (isLogin ? history.push('/account/wishlist') : history.push('/wishlist'))}>
                        {' '}
                        <img className="rcs_wishlist_icon" src={Heart1} alt={Heart1} />{' '}
                        <span className="dfl_right_menu_text" style={{ cursor: 'pointer' }}>
                          {' '}
                          Wishlist{' '}
                        </span>
                        {wishlistlength && wishlistlength != '0' ? <span className="rcs_wish_badge">{wishlistlength}</span> : ''}{' '}
                      </li>
                      <li
                        className=""
                        onClick={() => {
                          history.push('/cart');
                        }}
                      >
                        <img className="rcs_wishlist_icon" src={Cart1} alt={Cart1} />{' '}
                        <span className="dfl_right_menu_text" style={{ cursor: 'pointer' }}>
                          {' '}
                          Cart{' '}
                        </span>{' '}
                        {cartlength && cartlength != '0' ? <span className="rcs_cart_badge">{cartlength}</span> : ''}{' '}
                      </li>
                    </ul>
                  </div>
                  {/*fixed header wishlist search and login icon  */}
                </Col>

                <Col sm={12} md={12} lg={9} xs={12} className="rcs_large_Tab1" style={{ position: 'unset' }}>
                  {/* Menu Section */}
                  <div className="dfl_header_fixed_main_d">
                    <div className="rcs_menu">
                      <Container className="rcs_custome_container1">
                        <Row>
                          <nav id="rcs_menu_header_top">
                            <ul className="rcs_header_menu">
                              {menudata?.map((val1, ind) => (
                                <>
                                  {val1.menu_id == '2' ? (
                                    <li className="rcs_top_header_menu">
                                      <h6 onMouseEnter={() => setIsShown(ind + 1)} onMouseLeave={() => setIsShown(0)}>
                                        <NavLink to={val1.slug}> {val1.name} </NavLink>
                                      </h6>
                                      <div className={isShown == ind + 1 ? 'rcs_megaMenu d-block' : 'd-none'}>
                                        <div
                                          className="rcs_megaMenu_inner_top"
                                          onMouseEnter={() => setIsShown(ind + 1)}
                                          onMouseLeave={() => setIsShown(0)}
                                          style={{
                                            display: isShown == ind + 1 ? 'block' : 'none',
                                            padding: '0px 0 0',
                                          }}
                                        >
                                          <div className="rcs_megaMenu_inner">
                                            <Container fluid className="p-0">
                                              <Row className="w-100 m-auto">
                                                {val1?.submenu?.map((val1_sub) => (
                                                  <>
                                                    {val1_sub.menu_id == '42' && (
                                                      <Col lg={3} xl={3} className="p-0">
                                                        <div className="rcs_diamonds_content dfL-border_rel">
                                                          <h2> {val1_sub.name} </h2>

                                                          <Row className="m-auto w-100">
                                                            {val1_sub?.submenu?.map((val11) => (
                                                              <Col lg={6} className="cust_padd_diamonds_shape">
                                                                <div className="rcs_diamonds_content_inner">
                                                                  <NavLink to={val11.slug}>
                                                                    <Image src={val11.img_url} alt={val11.name}></Image>
                                                                    <p>{val11.name}</p>
                                                                  </NavLink>
                                                                </div>
                                                              </Col>
                                                            ))}
                                                          </Row>

                                                          <div className="dfl_menu_border"> </div>
                                                        </div>
                                                      </Col>
                                                    )}

                                                    {val1_sub.menu_id == '205' && (
                                                      <Col lg={2} xl={2} className="p-lg-0">
                                                        <div className="rcs_diamonds_content dfl_border_rel">
                                                          <div class="mega-list-cat">
                                                            <h2 class="title14 font-bold text-uppercase mtb">
                                                              {val1_sub?.name}
                                                            </h2>
                                                            <ul>
                                                              <li>
                                                                <Link to={val1_sub?.submenu[0]?.slug}> {val1_sub?.submenu[0]?.name} </Link>
                                                              </li>
                                                            </ul>
                                                          </div>

                                                          <div class="mega-list-cat m-top">
                                                            <h2 class="title14 font-bold text-uppercase mtb">
                                                              <Link to={val1_sub?.submenu[1]?.slug}>{val1_sub?.submenu[1]?.name}</Link>
                                                            </h2>
                                                            <ul>
                                                              {val1_sub?.submenu[1]?.submenu?.map((val11) => (
                                                                <li>
                                                                  <Link to={val11?.slug}> {val11?.name} </Link>
                                                                </li>
                                                              ))}{' '}
                                                            </ul>
                                                          </div>

                                                          <div className="dfl_menu_border"> </div>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub.menu_id == '37' && (
                                                      <Col lg={2} xl={2} className="p-lg-0">
                                                        <div className="rcs_diamonds_content">
                                                          <div class="mega-list-cat">
                                                            <h2 class="title14 font-bold text-uppercase mtb">{val1_sub.name}</h2>
                                                            <ul>
                                                              {val1_sub?.submenu?.map((val11) => (
                                                                <li>
                                                                  <Link to={val11.slug}>
                                                                    {' '}
                                                                    <img src={val11.img_url} className="img-size" alt={val11.name} /> {val11.name}
                                                                  </Link>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          </div>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub.menu_id == '209' && (
                                                      <Col lg={5} xl={5}>
                                                        <div className="rcs_diamonds_content">
                                                          <Link to={val1_sub.slug}>
                                                            <img
                                                              src={val1_sub.img_url}
                                                              alt={val1_sub.name}
                                                              className="img-fluid dfl_ddiamond_img"
                                                              style={{
                                                                height: '100%',
                                                                objectFit: 'cover',
                                                              }}
                                                            />
                                                          </Link>
                                                        </div>
                                                      </Col>
                                                    )}
                                                  </>
                                                ))}
                                              </Row>
                                            </Container>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  ) : val1.menu_id == '1' ? (
                                    <li className="rcs_top_header_menu">
                                      <h6 onClick={() => setIsShown(0)} onMouseEnter={() => setIsShown(ind + 1)} onMouseLeave={() => setIsShown(0)}>
                                        <NavLink to={val1?.slug}>{val1?.name}</NavLink>
                                      </h6>
                                      <div className={isShown == ind + 1 ? 'rcs_megaMenu d-block' : 'd-none'}>
                                        <div
                                          className="rcs_megaMenu_inner_top"
                                          onMouseEnter={() => setIsShown(ind + 1)}
                                          onMouseLeave={() => setIsShown(0)}
                                          style={{
                                            display: isShown == ind + 1 ? 'block' : 'none',
                                            padding: '0px 0 0',
                                          }}
                                        >
                                          <div className="rcs_megaMenu_inner">
                                            <Container fluid className="p-0">
                                              <Row className="w-100 m-auto">
                                                {val1?.submenu?.map((val1_sub) => (
                                                  <>
                                                    {val1_sub?.menu_id == '10' && (
                                                      <Col lg={3} xl={3}>
                                                        <div className="rcs_diamonds_content rcs_engagement dfl_border_rel">
                                                          <div class="mega-list-cat">
                                                            <h2 class="title14 font-bold text-uppercase mtb">
                                                              <NavLink to={val1_sub?.slug}>{val1_sub?.name}</NavLink>
                                                            </h2>
                                                            <ul>
                                                              {val1_sub?.submenu
                                                                ?.filter((v) => v.menu_id != '210')
                                                                ?.map((val11) => (
                                                                  <li>
                                                                    <Link to={val11?.slug}>
                                                                      {' '}
                                                                      <img src={val11?.img_url} class="img-size" alt={val11.name} />
                                                                      {val11.name}
                                                                    </Link>
                                                                  </li>
                                                                ))}
                                                            </ul>
                                                          </div>
                                                          {val1_sub?.submenu
                                                            ?.filter((v) => v.menu_id == '210')
                                                            ?.map((val11) => (
                                                              <div class="mega-list-cat m-top">
                                                                <h2 class="title14 font-bold text-uppercase mtb">
                                                                  <Link to={val11?.slug}>{val11?.name}</Link>
                                                                </h2>
                                                                <ul>
                                                                  {val11?.submenu?.map((v) =>
                                                                    v?.menu_id == '212' ? (
                                                                      <li onClick={() => window.open(v?.slug, '_blank')}>
                                                                        <Link to="#"> {v?.name}</Link>
                                                                      </li>
                                                                    ) : (
                                                                      <li>
                                                                        <Link to={v?.slug}> {v?.name}</Link>
                                                                      </li>
                                                                    ),
                                                                  )}
                                                                </ul>
                                                              </div>
                                                            ))}

                                                          <div className="dfl_menu_border"> </div>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub?.menu_id == '16' && (
                                                      <Col lg={3}>
                                                        <div className="rcs_diamonds_content rcs_engagement dfL-border_rel pl-0 pr-0">
                                                          <div
                                                            class="mega-list-cat"
                                                            style={{
                                                              display: 'flow-root',
                                                            }}
                                                          >
                                                            <h2 class="title14 font-bold  text-uppercase mtb">
                                                              <NavLink to={val1_sub?.slug}>{val1_sub?.name}</NavLink>
                                                            </h2>
                                                            <ul class="list-none dfl_megamenu_engag_list_of_s">
                                                              {val1_sub?.submenu
                                                                ?.filter((v) => v.menu_id != '15')
                                                                .map((val11) => (
                                                                  <li>
                                                                    <Link to={val11?.slug} onClick={() => localStorage.setItem('menuSelectedFilter', 'style')}>
                                                                      <img src={val11?.img_url} alt={val11?.name} class="engagement_img" /> {val11?.name}
                                                                    </Link>
                                                                  </li>
                                                                ))}
                                                            </ul>
                                                          </div>
                                                          {val1_sub?.submenu
                                                            ?.filter((v) => v.menu_id == '15')
                                                            .map((val11) => (
                                                              <div class="mega-list-cat m-top">
                                                                <h2 class="title14 font-bold text-uppercase mtb">
                                                                  <NavLink to={val11?.slug}>{val11?.name}</NavLink>
                                                                </h2>
                                                                <ul class="list-none dfl_megamenu_engag_list_of_s">
                                                                  {val11?.submenu?.map((val, index) => (
                                                                    <li>
                                                                      <Link to={val?.slug} onClick={() => localStorage.setItem('menuSelectedFilter', 'metal')}>
                                                                        <span class={'color-con con' + (index + 2)}></span>
                                                                        {val?.name}
                                                                      </Link>
                                                                    </li>
                                                                  ))}
                                                                </ul>
                                                              </div>
                                                            ))}
                                                          <div className="dfl_menu_border shope_by_style"> </div>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub?.menu_id == '25' && (
                                                      <Col lg={2}>
                                                        <div className="rcs_diamonds_content rcs_engagement dfl_border_rel pl-0 pr-0">
                                                          <div className="mega-list-cat">
                                                            <h2 className="title14 font-bold text-uppercase mtb">
                                                              <NavLink to={val1_sub?.slug}>{val1_sub?.name}</NavLink>
                                                            </h2>
                                                            <ul className="list1">
                                                              {val1_sub?.submenu?.map((val11) => (
                                                                <li>
                                                                  <Link to={val11?.slug} onClick={() => localStorage.setItem('menuSelectedFilter', 'shape')}>
                                                                    <img src={val11?.img_url} alt={val11?.name} className="img-size1" />
                                                                    {val11?.name}
                                                                  </Link>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          </div>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub?.menu_id == '32' && (
                                                      <Col lg={4} className="dfl_img_middle_align">
                                                        <div className="rcs_diamonds_content rcs_engagement pb-0 pl-0 pr-0 pt-0">
                                                          <Link to={val1_sub?.slug}>
                                                            <img src={val1_sub?.img_url} className="dfl_enggg_img" alt={val1_sub?.name} />
                                                          </Link>
                                                        </div>
                                                      </Col>
                                                    )}
                                                  </>
                                                ))}
                                              </Row>
                                            </Container>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  ) : val1.menu_id == '3' ? (
                                    <li className="rcs_top_header_menu">
                                      <h6 onClick={() => setIsShown(0)} onMouseEnter={() => setIsShown(ind + 1)} onMouseLeave={() => setIsShown(0)}>
                                        <NavLink to={val1?.slug}>{val1?.name}</NavLink>
                                      </h6>
                                      <div className={isShown == ind + 1 ? 'rcs_megaMenu d-block' : 'd-none'}>
                                        <div
                                          className="rcs_megaMenu_inner_top"
                                          onMouseEnter={() => setIsShown(ind + 1)}
                                          onMouseLeave={() => setIsShown(0)}
                                          style={{
                                            display: isShown == ind + 1 ? 'block' : 'none',
                                            padding: '0px 0 0',
                                          }}
                                        >
                                          <div className="rcs_megaMenu_inner">
                                            <Container fluid className="p-0">
                                              <Row className="w-100 m-auto">
                                                {val1?.submenu?.map((val1_sub) => (
                                                  <>
                                                    {val1_sub?.menu_id == '35' && (
                                                      <Col lg={4} xl={4} className="pr-0">
                                                        <div className="rcs_diamonds_content rcs_engagement dfL-border_rel pl-0 pr-0">
                                                          <div
                                                            class="mega-list-cat"
                                                            style={{
                                                              display: 'flow-root',
                                                            }}
                                                          >
                                                            <h2 class="title14 font-bold  text-uppercase mtb">
                                                              <NavLink to={val1_sub?.slug}>{val1_sub?.name}</NavLink>
                                                            </h2>
                                                            <ul class="list-none dfl_megamenu_engag_list_of_s">
                                                              {val1_sub?.submenu?.map((val11) => (
                                                                <li>
                                                                  <Link to={val11?.slug}>
                                                                    <img src={val11?.img_url} alt={val11?.name} class="engagement_img" /> {val11?.name}
                                                                  </Link>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          </div>
                                                          <div className="dfl_menu_border shope_by_style"> </div>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub?.menu_id == '91' && (
                                                      <Col lg={2} xl={2} className="p-0 rcs_right_bg">
                                                        <div className="rcs_diamonds_content dfl_wedding_Content_metal_type">
                                                          <div class="mega-list-cat">
                                                            <h2 class="title14 font-bold text-uppercase mtb">
                                                              <NavLink to={val1_sub?.slug}>{val1_sub?.name}</NavLink>
                                                            </h2>
                                                            <ul class="list-none">
                                                              {val1_sub?.submenu?.map((val11, index) => (
                                                                <li>
                                                                  <Link to={val11?.slug}>
                                                                    <span class={'color-con con' + (index + 2)}></span>
                                                                    {val11?.name}
                                                                  </Link>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          </div>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub?.menu_id == '97' && (
                                                      <Col lg={6} xl={6} className="p-0 rcs_right_bg">
                                                        <div className="rcs_diamonds_content">
                                                          <Link to={val1_sub?.slug}>
                                                            <img src={val1_sub?.img_url} className="dfl_weddingg_img" alt={val1_sub?.name} />
                                                          </Link>
                                                        </div>
                                                      </Col>
                                                    )}
                                                  </>
                                                ))}
                                              </Row>
                                            </Container>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  ) : val1.menu_id == '4' ? (
                                    <li className="rcs_top_header_menu">
                                      <h6 onClick={() => setIsShown(0)} onMouseEnter={() => setIsShown(ind + 1)} onMouseLeave={() => setIsShown(0)}>
                                        <NavLink to={val1?.slug}>{val1?.name} </NavLink>
                                      </h6>
                                      <div className={isShown == ind + 1 ? 'rcs_megaMenu d-block' : 'd-none'}>
                                        <div
                                          className="rcs_megaMenu_inner_top"
                                          onMouseEnter={() => setIsShown(ind + 1)}
                                          onMouseLeave={() => setIsShown(0)}
                                          style={{
                                            display: isShown == ind + 1 ? 'block' : 'none',
                                            padding: '0px 0 0',
                                          }}
                                        >
                                          <div className="rcs_megaMenu_inner">
                                            <Container fluid className="p-0">
                                              <Row className="w-100 m-auto">
                                                {val1?.submenu?.map((val1_sub) => (
                                                  <>
                                                    {val1_sub?.menu_id == '6' && (
                                                      <Col lg={2} xl={2} className="pr-0">
                                                        <div className="rcs_diamonds_content rcs_engagement dfL-border_rel pl-0 pr-0">
                                                          <div
                                                            class="mega-list-cat"
                                                            style={{
                                                              display: 'flow-root',
                                                            }}
                                                          >
                                                            <h2 className="title14 font-bold  text-uppercase mtb">
                                                              <NavLink to={val1_sub?.slug}>{val1_sub?.name}</NavLink>
                                                            </h2>
                                                            <ul className="list-none dfl_ring_stylee_outer_box">
                                                              {val1_sub?.submenu?.map((val11) => (
                                                                <li>
                                                                  <Link to={val11?.slug}>
                                                                    <img src={val11?.img_url} alt={val11?.name} class="engagement_img" /> {val11?.name}
                                                                  </Link>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          </div>
                                                          <div className="dfl_menu_border shope_by_style"> </div>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub?.menu_id == '7' && (
                                                      <Col lg={2} xl={2} className="p-0 rcs_right_bg">
                                                        <div className="rcs_diamonds_content dfl_wedding_Content_metal_type">
                                                          <div class="mega-list-cat">
                                                            <h2 class="title14 font-bold text-uppercase mtb">
                                                              <NavLink to={val1_sub?.slug}>{val1_sub?.name}</NavLink>
                                                            </h2>
                                                            <ul class="list-none">
                                                              {val1_sub?.submenu?.map((val11, index) => (
                                                                <li>
                                                                  <Link to={val11?.slug}>
                                                                    <span class={'color-con con' + (index + 2)}></span>
                                                                    {val11?.name}
                                                                  </Link>
                                                                </li>
                                                              ))}
                                                            </ul>
                                                          </div>
                                                        </div>
                                                        <div className="dfl_menu_border shope_by_style"> </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub?.menu_id == '224' && (
                                                      <Col lg={2} xl={2} className="p-0 rcs_right_bg">
                                                        <div className="rcs_diamonds_content dfl_wedding_Content_metal_type">
                                                          <div class="mega-list-cat">
                                                            <h2 class="title14 font-bold text-uppercase mtb">
                                                              <NavLink to={val1_sub?.slug}>{val1_sub?.name}</NavLink>
                                                            </h2>
                                                            <ul class="list-none">
                                                              {val1_sub?.submenu?.map((val11) =>
                                                                val11.menu_id == '226' ? (
                                                                  <li onClick={() => window.open(val11.slug, '_blank')}>
                                                                    <Link to="#">{val11?.name}</Link>
                                                                  </li>
                                                                ) : (
                                                                  <li>
                                                                    <Link to={val11?.slug}>{val11?.name} </Link>
                                                                  </li>
                                                                ),
                                                              )}
                                                            </ul>
                                                          </div>
                                                        </div>
                                                      </Col>
                                                    )}
                                                    {val1_sub?.menu_id == '8' && (
                                                      <Col lg={6} xl={6} className="p-0 rcs_right_bg">
                                                        <div className="rcs_diamonds_content">
                                                          <Link to={val1_sub?.slug}>
                                                            <img src={val1_sub?.img_url} alt={val1_sub?.name} className="dfl_fineee_img" />
                                                          </Link>
                                                        </div>
                                                      </Col>
                                                    )}
                                                  </>
                                                ))}
                                              </Row>
                                            </Container>
                                          </div>
                                        </div>
                                      </div>
                                    </li>
                                  ) : (
                                    <li className="rcs_top_header_menu">
                                      <h6 onClick={() => setIsShown(0)} onMouseEnter={() => setIsShown(ind + 1)} onMouseLeave={() => setIsShown(0)}>
                                        <NavLink to={val1?.slug}>{val1?.name} </NavLink>
                                      </h6>
                                    </li>
                                  )}
                                </>
                              ))}
                            </ul>
                          </nav>
                        </Row>
                      </Container>
                    </div>
                    <div className="dfl_header_with_calander_on_sticky dfl_number_with_calender_box align-items-center">
                      <VscCalendar className="dfl_ringb_calander_icon dfl_cal_only_on_stiky_dektop_heder" onClick={() => history.push('/make-an-appointment')} title="Book An Appointment" />
                      <div className="dfl_top_right_number header_fixed_view">
                        <svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 16 16" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"></path>
                        </svg>
                        <a href="tel:+1 416 362 9944">+1 416 362 9944</a>
                      </div>
                    </div>
                  </div>

                  {/* menu Section */}
                </Col>
              </Row>
            </Container>
          </div>

          {/* <div className="dfl_new_top_hader0 dfl_top_new_header0__on_sticky p-0">
            <Container fluid>
              <Row>
              <HoliDaysHeading/>
              </Row>
            </Container>
          </div> */}
          {/* Header Section */}
        </div>
        {/* Mobile Menu drawer */}
        <div className="rcs_menu_mobile d-none">
          <Container>
            <Row>
              <Drawer anchor="left" open={left} onClose={() => toggleDrawer(false)}>
                <div role="presentation" onKeyDown={() => toggleDrawer(false)}>
                  <div className="rcs_mobile_menu ">
                    <div className={classes.root}>
                      <div className="mobile_drawer_icon_box">
                        <div className="dfl_top_right_cont_main mt-2">
                          <div className="rcs_search_bar dfl_top_search">
                            <div className="rcs_right_side dfl_right_icn_content ">
                              <ul>
                                <li className="d-none d-lg-block d-md-block dfl_tab_search position-relative" onClickAway={() => setSearch_show(false)} onClick={() => toggleDrawer(false)}>
                                  <img onClick={() => setSearch_show(!search_show)} className="rcs_wishlist_icon" src={Magnify0} alt={Magnify0} />
                                  <Modal className={isScrollValueMoreThanHeaderHeight ? 'rcs_search_modal12' : 'rcs_search_modal'} show={search_show} onHide={() => setSearch_show(false)}>
                                    <div className="rcs_search_bar">
                                      <Form
                                        onSubmit={(e) => {
                                          e.preventDefault();
                                          history.push('/search/' + search_text);
                                          window.scrollTo(0, 0);
                                          setSearch_text('');
                                          setSearch_show(false);
                                        }}
                                      >
                                        <SearchIcon
                                          onClick={(e) => {
                                            history.push('/search/' + search_text);
                                            setSearch_text('');
                                            setSearch_show(false);
                                          }}
                                        />
                                        <Form.Control type="text" placeholder="Search for.." value={search_text} onChange={(e) => setSearch_text(e.target.value)} />
                                        <AiOutlineClose onClick={() => setSearch_show(!search_show)} />
                                      </Form>
                                    </div>
                                  </Modal>
                                </li>
                                {isLogin ? (
                                  <>
                                    <Button className="rcs_blank_button rcs_after_login_button" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClicktop}>
                                      {isMobileOnly ? (
                                        <span className="rcs_mobile">{user.first_name[0]}</span>
                                      ) : isTablet ? (
                                        <span className="rcs_mobile">{user.first_name[0]}</span>
                                      ) : (
                                        <span className="rcs_mobile">
                                          {user.first_name[0]} <KeyboardArrowDownIcon />{' '}
                                        </span>
                                      )}
                                    </Button>
                                    <Menu id="simple-menu" anchorEl={anchorEl} keepMounted className="rcs_menu_list_item" open={Boolean(anchorEl)} onClick={handleClosetop}>
                                      <MenuItem disabled>
                                        <BiUser /> {user.first_name}
                                      </MenuItem>
                                      <MenuItem onClick={() => history.push('/account/myaccount')}>My Account</MenuItem>
                                      <MenuItem onClick={handlelogout}>Logout</MenuItem>
                                    </Menu>
                                  </>
                                ) : (
                                  <li
                                    className="position-relative"
                                    onClick={() => {
                                      toggleDrawer(false);
                                      history.push('/login');
                                    }}
                                  >
                                    {' '}
                                    <img className="rcs_wishlist_icon" src={User1} alt={User1} />{' '}
                                    <span className="dfl_right_menu_text" style={{ cursor: 'pointer' }}>
                                      {' '}
                                    </span>{' '}
                                  </li>
                                )}
                                <li
                                  className="position-relative"
                                  onClick={() => {
                                    toggleDrawer(false);
                                    isLogin ? history.push('/account/wishlist') : history.push('/wishlist');
                                  }}
                                >
                                  {' '}
                                  <img className="rcs_wishlist_icon" src={Heart1} alt={Heart1} />{' '}
                                  <span className="dfl_right_menu_text" style={{ cursor: 'pointer' }}>
                                    {' '}
                                  </span>
                                  {wishlistlength && wishlistlength != '0' ? <span className="rcs_wish_badge">{wishlistlength}</span> : ''}{' '}
                                </li>
                                <li
                                  className="position-relative"
                                  onClick={() => {
                                    toggleDrawer(false);
                                    history.push('/cart');
                                  }}
                                >
                                  <img className="rcs_wishlist_icon" src={Cart1} alt={Cart1} />{' '}
                                  <span className="dfl_right_menu_text" style={{ cursor: 'pointer' }}>
                                    {' '}
                                  </span>{' '}
                                  {cartlength && cartlength != '0' ? <span className="rcs_cart_badge">{cartlength} </span> : ''}{' '}
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      {menudata.length > 0 &&
                        menudata?.map((value) => (
                          <Accordion key={value?.slug}>
                            {value?.submenu?.length > 0 ? (
                              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                <Typography
                                  className={classes.heading}
                                  onClick={() => {
                                    history.push(value?.slug);
                                    toggleDrawer(false);
                                  }}
                                >
                                  {value?.name}
                                </Typography>
                              </AccordionSummary>
                            ) : (
                              <AccordionDetails className="rcs_mobile_inner_menu2">
                                <Typography
                                  onClick={() => {
                                    history.push(value?.slug);
                                    toggleDrawer(false);
                                  }}
                                >
                                  {value.name}
                                </Typography>
                              </AccordionDetails>
                            )}
                            {value?.submenu?.length > 0
                              ? value?.submenu?.map((val) => (
                                <AccordionDetails key={val?.slug} className={val?.submenu?.length ? 'rcs_mobile_inner_menu' : 'rcs_mobile_inner_menu1'}>
                                  {val?.submenu?.length == 0 ? (
                                    <Typography
                                      onClick={() => {
                                        toggleDrawer(false);
                                        history.push(val?.slug);
                                      }}
                                    >
                                      {val.name}
                                    </Typography>
                                  ) : (
                                    <Accordion>
                                      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                                        <Typography
                                          onClick={() => {
                                            toggleDrawer(false);
                                            history.push(val?.slug);
                                          }}
                                          className={classes.heading}
                                        >
                                          {val.name}
                                        </Typography>
                                      </AccordionSummary>
                                      {val?.submenu.length > 0 &&
                                        val?.submenu?.map((val1) => (
                                          <AccordionDetails className="rcs_mobile_inner_menu1" key={val1?.slug}>
                                            <Typography
                                              onClick={() => {
                                                toggleDrawer(false);
                                                history.push(val1?.slug);
                                              }}
                                            >
                                              {val1.name}
                                            </Typography>
                                          </AccordionDetails>
                                        ))}
                                    </Accordion>
                                  )}
                                </AccordionDetails>
                              ))
                              : ''}
                          </Accordion>
                        ))}

                      <div className="dfl_mobile_header_Contact_us_section">
                        <h6 onClick={() => {
                          toggleDrawer(false);
                        }}><NavLink to="/contact-us" className="dark ">Contact Us</NavLink></h6>
                        <div className="dfl_con_icon_box_outer">
                          <div className="dfl_con_icon_box" onClick={() => window.open('https://wa.me/+14163629944', '_blank')}>
                            <BsFillChatFill />
                          </div>
                          <div className="dfl_con_icon_box">
                            <a href="tel:+1 416 362 9944">
                              <MdOutlineCall />
                            </a>
                          </div>
                          <div className="dfl_con_icon_box">
                            <a to="mailto:info@diamondsforless.ca" target="_blank">
                              <MdEmail />
                            </a>
                          </div>
                          {/* <div className='dfl_con_icon_box'>
                                                        <AiOutlineContacts/>
                                                    </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Drawer>
            </Row>
          </Container>
        </div>
        {/* Mobile Menu Section */}
      </div>
    </>
  );
};
export default React.memo(Header);
